import React from 'react';
import paginationLastDisabled from '../assets/images/pagination-last-disabled.svg';

export default () => {
  return <img src={paginationLastDisabled} alt="Last Page Disabled" />;
};
